import { render, staticRenderFns } from "./NewTaskTodo.vue?vue&type=template&id=7a70753d&scoped=true&"
import script from "./NewTaskTodo.vue?vue&type=script&lang=js&"
export * from "./NewTaskTodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a70753d",
  null
  
)

export default component.exports